import React, { FC } from 'react';
import { getContext, I18n } from '@fiverr-private/fiverr_context';
import pathfinder from '@fiverr-private/pathfinder';
import { useNavbar } from '../../../hooks/useNavbar';
import { ArticlePreview, Author, CategoryPreview } from '../../../../shared/types';
import { calculateCategoryLink, calculateArticleLink } from '../helpers';
import { AboutAuthor } from '../AboutAuthor';
import SidebarTOC from './SidebarTOC';

import './index.scss';

interface NavbarProps {
  categories: CategoryPreview[];
  topArticles: ArticlePreview[];
  author?: Author;
}

const Navbar: FC<NavbarProps> = (props) => {
  const { categories, topArticles, author } = props;
  const { isOpened, toggle } = useNavbar();
  const {
    pathParameters: { category: categoryUrlParam },
  } = getContext();

  return (
    <nav className={`left-navbar ${isOpened ? 'opened' : ''}`}>
      <div className="mobile-overlay" onClick={toggle} />
      <div className="sticky-content">
        {author && <AboutAuthor {...author} variant="sidebar" />}
        <SidebarTOC />
        {categories.length > 0 && (
          <>
            <h5>
              <I18n k="fiverr_guides.navbar.categories.label" />
            </h5>
            <ul className="categories">
              {categories.map((category, index) => (
                <li key={index} className={category.handle.split('/')[1] === categoryUrlParam ? 'active' : ''}>
                  <a href={calculateCategoryLink(category)}>{category.title}</a>
                </li>
              ))}
            </ul>
          </>
        )}
        {topArticles.length > 0 && (
          <>
            <h2 className="top-articles-heading">
              <I18n k="fiverr_guides.navbar.popular_guides.label" />
            </h2>
            <div>
              <ul className="top-articles">
                {topArticles.map((article, index) => (
                  <li key={index}>
                    <h3>
                      <a href={calculateArticleLink(article)}>{article.title}</a>
                    </h3>
                  </li>
                ))}
              </ul>
            </div>
          </>
        )}
        <a href={pathfinder('root')} className="fiverr-link nav-link" target="_blank">
          {<I18n k="fiverr_guides.header.go_to_fiverr" />}
        </a>
      </div>
    </nav>
  );
};

export default Navbar;
